import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import DropdownV3 from '@zola/zola-ui/src/components/Form/dropdownV3';

// Components
import DropdownSelect from 'cards/components/common/DropdownSelect/DropdownSelect';
import { CustomizeCardButton } from 'cards/components/CardDetail/CustomizeCardButton';

// Utils
import { enrichQtyOptions } from 'cards/util/productDetail';
import { priceFormatter } from 'components/product/PricingUtils';

// Styles
import styles from './styles.module.less';

const QtyPriceSection = ({
  cost,
  defaultSelection,
  showDropdownOptionsOnTop,
  increment,
  max,
  min,
  onSelect,
  hideTitle,
  handleCustomizeClick,
  disableCustomizeButton,
  proofAllowed,
  isMagnet,
  isRedesigned = false,
  promoCode = '',
}) => {
  const [currentValue, setCurrentValue] = useState(defaultSelection);

  useEffect(() => {
    if (isMagnet && currentValue === 1) {
      setCurrentValue(defaultSelection);
      onSelect(defaultSelection);
    }
  }, [isMagnet, defaultSelection, currentValue, onSelect]);

  function onMobileChange(event) {
    event.preventDefault();
    const newVal = parseInt(event.target.value, 10);
    setCurrentValue(newVal);
    onSelect(newVal);
  }

  function onDesktopChange(newVal) {
    setCurrentValue(newVal);
    onSelect(newVal);
  }

  const options = enrichQtyOptions(min, max, increment, proofAllowed, !isRedesigned, false);
  const mblOptions = enrichQtyOptions(min, max, increment, proofAllowed, !isRedesigned, true);

  return (
    <div className={isRedesigned ? styles.redesigned : ''}>
      <div className={cx(styles.header, { [styles.collapsed]: hideTitle })}>
        <span className={styles.title}>Quantity</span>
        {promoCode && <span className={styles.promoCode}>{promoCode}</span>}
      </div>
      <div className={styles.productDetailPriceSection}>
        {isRedesigned ? (
          <DropdownV3
            className={styles.qtySelect}
            options={options}
            value={currentValue}
            onSelect={onDesktopChange}
          />
        ) : (
          <div className={styles.qtySelect}>
            <DropdownSelect
              showOptionsOnTop={showDropdownOptionsOnTop}
              selected={currentValue}
              options={options}
              onSelect={onDesktopChange}
              matchButtonV2
            />
          </div>
        )}
        <div className={styles.mobileSelectContainer}>
          <select
            value={currentValue}
            onChange={onMobileChange}
            name="detailPrice"
            id="detail-price"
            className={styles.mobileSelect}
          >
            {mblOptions.map(each => (
              <option key={each.label} value={each.value}>
                {each.label}
              </option>
            ))}
          </select>
        </div>
        <CustomizeCardButton
          className={styles.customizeCta}
          handleCustomizeClick={handleCustomizeClick}
          disabled={disableCustomizeButton}
        />
        <div className={styles.priceTotal}>
          <span>{priceFormatter(cost.total)}</span>
        </div>
      </div>
    </div>
  );
};

export default QtyPriceSection;
